/**
 * Contrato zod del catálogo de eventos ANMAT (SNT).
 *
 * El catálogo oficial tiene 524 entradas; en el mock cargamos solo las que
 * cubren los flujos del seed (~30 entradas clave). En producción Eze carga
 * el CSV completo desde la fuente ANMAT.
 */

import { z } from 'zod';
import { TipoActorSchema } from './ubicaciones';

export const EventoAnmatSchema = z.object({
  id: z.number().int().positive(),
  evento: z.string().min(1),
  informador: TipoActorSchema,
  origen: TipoActorSchema,
  /** `null` para eventos terminales (destrucción, robo, vencimiento sin destinatario). */
  destino: TipoActorSchema.nullable(),
});

export const GetEventosAnmatResponse = z.array(EventoAnmatSchema);

export type EventoAnmat = z.infer<typeof EventoAnmatSchema>;
